import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const useDebouncedValue = <V>(
  value: V,
  delay = 100
): [debouncedValue: V, setValueImmediately: Dispatch<SetStateAction<V>>] => {
  const [debouncedValue, setValue] = useState<V>(value);

  useEffect(() => {
    const timer = setTimeout(setValue, delay, value);

    return () => clearTimeout(timer);
  }, [value, setValue, delay]);

  return [debouncedValue, setValue];
};

export default useDebouncedValue;
